<template>
  <v-row class="mb-6">
    <v-col cols="12" class="historic-limit-item__content pa-5">
      <v-row>
        <v-col cols="11" class="pl-4">
          <p class="font-weight-bold primary--text">
            {{ formatTitle }}
          </p>
        </v-col>
        <v-col cols="1">
          <BaseButton icon @click="showResumeQuotation()">
            <v-icon color="primary" size="14"> {{ iconShowResume }} </v-icon>
          </BaseButton>
        </v-col>
      </v-row>
      <v-row
        class="white px-8 pb-9 pt-6 historic-limit-item__radius"
        v-if="isActiveResume"
      >
        <v-col cols="12" sm="6" class="pr-sm-5 pb-9">
          <DetailsItemHistoricLimit title="Status" :item="item.status.nome" />
        </v-col>
        <v-col cols="12" sm="6" class="pb-9">
          <DetailsItemHistoricLimit
            title="Data"
            :item="formatIsoDateToDDMMYYYY(item.status_alterado_em)"
          />
        </v-col>
        <v-col cols="12">
          <p class="form__title primary--text mb-6">
            RELACIONAMENTO SEGURADORA
          </p>
          <BaseDataTable
            :headers="tableHeaders"
            :items="item.contatos_relacionamento"
            hide-default-footer
          />
        </v-col>
        <v-col cols="12" class="pt-10">
          <p class="form__title primary--text mb-3">
            DADOS FINANCEIROS
          </p>
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5 mb-3">
          <DetailsItemHistoricLimit
            title="Limite de Crédito"
            :item="asMoneyString(item.valor_limite_credito)"
          />
        </v-col>
        <v-col cols="12" sm="6" class="mb-3">
          <DetailsItemHistoricLimit title="Validade" :item="formatValid" />
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5 mb-3">
          <DetailsItemHistoricLimit
            title="Aprovador 1"
            :item="concatName(item.aprovadores_n1)"
          />
        </v-col>
        <v-col cols="12" sm="6" class="mb-3">
          <DetailsItemHistoricLimit
            title="Aprovador 2"
            :item="concatName(item.aprovadores_n2)"
          />
        </v-col>
        <v-col cols="12" class="pt-8">
          <p class="form__title primary--text mb-3">
            COMISSÃO BASE
          </p>
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5 mb-3">
          <DetailsItemHistoricLimit
            title="Perc. Comissão"
            :item="item.percentual_comissao + '%'"
          />
        </v-col>
        <v-col cols="12" class="pt-8">
          <p class="form__title primary--text mb-3">
            DADOS CCG
          </p>
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5 mb-5">
          <DetailsItemHistoricLimit
            title="Emissão s/ CCG"
            :item="asMoneyString(item.valor_emissao_sem_ccg)"
          />
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-5 mb-5">
          <DetailsItemHistoricLimit
            title="Estrutura"
            :item="item.estrutura_ccg.nome"
          />
        </v-col>
        <v-col cols="12" sm="10">
          <DocumentDataTable
            :documents="[item.ccg_arquivo]"
            @preview-file="onPreviewFile"
            :delete-button="false"
          />
        </v-col>
        <v-col cols="12" class="py-10">
          <v-divider />
        </v-col>
        <v-col cols="12">
          <p class="form__title primary--text mb-3">
            MODALIDADES
          </p>
          <BaseDataTable
            :headers="modalityTableHeaders"
            :items="item.modalidades"
            hide-default-footer
          >
            <template v-slot:[`item.valor_limite_credito`]="{ item }">
              {{ asMoneyString(item.valor_limite_credito) }}
            </template>
            <template v-slot:[`item.valor_maximo_apolice`]="{ item }">
              {{ asMoneyString(item.valor_maximo_apolice) }}
            </template>
            <template v-slot:[`item.valor_sem_ccg`]="{ item }">
              {{ asMoneyString(item.valor_sem_ccg) }}
            </template>
            <template v-slot:[`item.percentual_comissao`]="{ item }">
              {{ item.percentual_comissao }}%
            </template>
            <template v-slot:[`item.percentual_taxa`]="{ item }">
              {{ item.percentual_taxa }}%
            </template>
          </BaseDataTable>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
const tableHeaders = [
  { text: "Nome", value: "nome", sortable: false },
  { text: "E-mail", value: "email", sortable: false },
  { text: "Telefone", value: "telefone1", sortable: false },
  { text: "Departamento", value: "departamento", sortable: false }
];
const modalityTableHeaders = [
  { text: "Modalidade", value: "modalidade.nome", sortable: false },
  { text: "Lim. de Créd.", value: "valor_limite_credito", sortable: false },
  { text: "Lim. p/ Apólice", value: "valor_maximo_apolice", sortable: false },
  { text: "Lim. s/ CCG", value: "valor_sem_ccg", sortable: false },
  { text: "Taxa (base)", value: "percentual_taxa", sortable: false },
  { text: "Comissão (base)", value: "percentual_comissao", sortable: false }
];
import DetailsItemHistoricLimit from "./DetailsItemHistoricLimit";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import DocumentDataTable from "@/components/DocumentDataTable";
import {
  asMoneyString,
  formatIsoDateToDDMMYYYY,
  formatHistoricLimitDate
} from "@/utils/formats.js";
export default {
  data: () => ({
    isActiveResume: false,
    tableHeaders,
    modalityTableHeaders,
    asMoneyString,
    formatIsoDateToDDMMYYYY,
    formatHistoricLimitDate
  }),
  components: {
    DetailsItemHistoricLimit,
    DocumentDataTable
  },
  mixins: [DocumentsMixin],
  computed: {
    iconShowResume() {
      return this.isActiveResume ? "fa-chevron-up" : "fa-chevron-down";
    },
    formatValid() {
      return `DE ${formatIsoDateToDDMMYYYY(
        this.item.inicio_validade
      )} ATÉ ${formatIsoDateToDDMMYYYY(this.item.final_validade)}`;
    },
    formatTitle() {
      return `${this.formatHistoricLimitDate(
        this.item.inicio_validade
      )} - ${this.formatHistoricLimitDate(this.item.final_validade)}`;
    }
  },
  methods: {
    showResumeQuotation() {
      this.isActiveResume = !this.isActiveResume;
    },
    convertBoolean(item) {
      return item ? "SIM" : "NÃO";
    },
    concatName(item) {
      return item.reduce((acc, { nome }) => acc.concat(nome + " "), "");
    }
  },
  props: {
    item: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.historic-limit-item__
  &content
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
  &radius
    border-radius: 2px
  &title
    font-weight: 800
    font-size: 18px
</style>
